import { useState, useEffect } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import Preloader from './components/Preloader'
import Header from './components/Header'
import Hero from './components/Hero'
import ExpertiseAccordion from './components/ExpertiseAccordion'
import ContactCTA from './components/ContactCTA'
import Sobre from './components/Sobre'

const PRELOADER_KEY = 'preloader_seen_at'
const PRELOADER_TTL_MS = 30 * 24 * 60 * 60 * 1000 // 30 dias

function alreadySeenPreloader(): boolean {
  if (typeof window === 'undefined') return false
  // ?intro=force força exibição (útil pra screenshots/teste)
  if (window.location.search.includes('intro=force')) {
    window.localStorage.removeItem(PRELOADER_KEY)
    return false
  }
  const raw = window.localStorage.getItem(PRELOADER_KEY)
  if (!raw) return false
  const ts = parseInt(raw, 10)
  if (Number.isNaN(ts)) return false
  return (Date.now() - ts) < PRELOADER_TTL_MS
}

export default function App() {
  const [ready, setReady] = useState(() => alreadySeenPreloader())
  const [sobreOpen, setSobreOpen] = useState(false)
  const [theme, setTheme] = useState<'dark' | 'light'>(() => {
    try { return (localStorage.getItem('site_theme') as 'dark' | 'light') || 'dark' } catch { return 'dark' }
  })

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
    try { localStorage.setItem('site_theme', theme) } catch {}
  }, [theme])

  const handlePreloaderDone = () => {
    try { window.localStorage.setItem(PRELOADER_KEY, String(Date.now())) } catch {}
    setReady(true)
  }

  return (
    <>
      <AnimatePresence mode="wait">
        {!ready && <Preloader key="preloader" onDone={handlePreloaderDone} />}
      </AnimatePresence>

      <motion.div
        initial={{ opacity: ready ? 1 : 0 }}
        animate={{ opacity: ready ? 1 : 0 }}
        transition={{ duration: ready ? 0 : 0.6 }}
      >
        <Header
          onSobre={() => setSobreOpen(true)}
          theme={theme}
          onToggleTheme={() => setTheme(t => t === 'dark' ? 'light' : 'dark')}
        />
        <main>
          <Hero />
          <ExpertiseAccordion />
          <ContactCTA />
        </main>
      </motion.div>

      <Sobre open={sobreOpen} onClose={() => setSobreOpen(false)} />
    </>
  )
}
